function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsTotalConsumer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 55,
    viewBox: "0 0 43 55",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icons/Total consumer",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17691"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17690"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17689"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17688"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51023",
    d: "M147.357 111.445a6.15 6.15 0 1 0-6.143 6.445 6.307 6.307 0 0 0 6.143-6.445zm-4.607 6.445h-3.071a7.883 7.883 0 0 0-7.679 8.057 1.575 1.575 0 0 0 1.536 1.611h15.357a1.575 1.575 0 0 0 1.536-1.611 7.883 7.883 0 0 0-7.679-8.056zm29.179 6.445a6.15 6.15 0 1 0-6.143 6.445 6.307 6.307 0 0 0 6.143-6.444zm-13.822 16.113h15.357a1.575 1.575 0 0 0 1.536-1.61 7.883 7.883 0 0 0-7.679-8.057h-3.071a7.883 7.883 0 0 0-7.679 8.057 1.575 1.575 0 0 0 1.536 1.611zm-9.214-9.668h-15.357a1.575 1.575 0 0 0-1.536 1.613v26a1.575 1.575 0 0 0 1.536 1.607h15.357a1.575 1.575 0 0 0 1.536-1.611v-26a1.575 1.575 0 0 0-1.536-1.608zm24.571 12.891h-15.357a1.575 1.575 0 0 0-1.536 1.611v13.105a1.575 1.575 0 0 0 1.536 1.613h15.357a1.575 1.575 0 0 0 1.536-1.611v-13.106a1.575 1.575 0 0 0-1.536-1.611z",
    transform: "translate(-132 -105)",
    style: {
      fill: "#fff"
    }
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsTotalConsumer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icons_Total consumer.d292b4922b3b342e564dfe7c6c75f8f9.svg";